module.exports = "/static/images/bct-divider-dark.svg";